import { Injectable } from '@angular/core';
import { appConfig } from '../app.config';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
import { GeographicalAddresses, GeographicalAddressesList, GeolocationCoordinatesAddresses, GeolocationCoordinatesAddressesList, PostalAddresses, PostalAddressesList } from './models/AddressModel';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  config:any;
    apiUrl: string='';
    constructor(private apiService: CommonService) {
      this.config=appConfig
      this.apiUrl=appConfig.AddressServiceUrl;
     }

    getGeographicalAddresses(url):Observable<GeographicalAddressesList> {
      let data = this.apiService.getServiceCall(`${this.apiUrl}/get-geographical-addresses`, url) as Observable<GeographicalAddressesList>;
      return this.apiService.response(data,GeographicalAddressesList,'geographical-addresses') as Observable<GeographicalAddressesList>;
    }

    getGeographicalAddressesById(url):Observable<GeographicalAddresses> {
        let data = this.apiService.getServiceCall(`${this.apiUrl}/get-geographical-addresses`, url) as Observable<GeographicalAddresses>;
        return this.apiService.response(data,GeographicalAddresses,'geographical-addresses') as Observable<GeographicalAddresses>;
      }

    createGeographicalAddresses(url,data):Observable<GeographicalAddresses> {
      return this.apiService.postServiceCall(`${this.apiUrl}/create-geographical-addresses`, url,data) as Observable<GeographicalAddresses>;
    }

    updateGeographicalAddresses(url,data):Observable<GeographicalAddresses> {
      return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-geographical-addresses`, url,data) as Observable<GeographicalAddresses>;
    }

    getGeolocationCoordinatesAddresses(url):Observable<GeolocationCoordinatesAddressesList> {
      let data = this.apiService.getServiceCall(`${this.apiUrl}/get-geolocation-coordinates-addresses`, url) as Observable<GeolocationCoordinatesAddressesList>;
      return this.apiService.response(data,GeolocationCoordinatesAddressesList,'geolocation-coordinates-addresses') as Observable<GeolocationCoordinatesAddressesList>;
    }

    getGeolocationCoordinatesAddressesById(url):Observable<GeolocationCoordinatesAddresses> {
      let data = this.apiService.getServiceCall(`${this.apiUrl}/get-geolocation-coordinates-addresses`, url) as Observable<GeolocationCoordinatesAddresses>;
      return this.apiService.response(data,GeolocationCoordinatesAddresses,'geolocation-coordinates-addresses') as Observable<GeolocationCoordinatesAddresses>;
    }

    createGeolocationCoordinatesAddresses(url,data):Observable<GeolocationCoordinatesAddresses> {
      return this.apiService.postServiceCall(`${this.apiUrl}/create-geolocation-coordinates-addresses`, url,data) as Observable<GeolocationCoordinatesAddresses>;
    }

    updateGeolocationCoordinatesAddresses(url,data):Observable<GeolocationCoordinatesAddresses> {
      return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-geolocation-coordinates-addresses`, url,data) as Observable<GeolocationCoordinatesAddresses>;
    }

    getPostalAddresses(url):Observable<PostalAddressesList> {
      let data = this.apiService.getServiceCall(`${this.apiUrl}/get-postal-addresses`, url) as Observable<PostalAddressesList>;
      return this.apiService.response(data,PostalAddressesList,'postal-addresses') as Observable<PostalAddressesList>
    }

    getPostalAddressesById(url):Observable<PostalAddresses> {
      let data = this.apiService.getServiceCall(`${this.apiUrl}/get-postal-addresses`, url) as Observable<PostalAddresses>;
      return this.apiService.response(data,PostalAddresses,'postal-addresses') as Observable<PostalAddresses>;
    }

    updatePostalAddresses(url,data):Observable<PostalAddresses> {
      return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-postal-addresses`, url,data) as Observable<PostalAddresses>;
    }


}
